import styled from 'styled-components';
import white from 'sushiweb/tokens/color/white';
import ZImage from 'sushiweb/ZImage/ZImage';

export const LoaderContainer = styled.div`
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  background: ${white};
`;

export const ZLogoWrapper = styled(ZImage)`
  margin-bottom: 3.2rem;
`;
